<template>
  <div class="forumInfo">
    <homeHead></homeHead>
    <homeNav  :routerName="'forum'"  ></homeNav>
    <div class="colspan">
      <div class="weizhi">
        <img src="../../assets/images/weizhi.png" alt /> 您当前所在的位置：
      </div>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{path:'/forum'}">话题</el-breadcrumb-item>
        <el-breadcrumb-item @click="goTo">话题详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div id="list" class="list-box">
      <div class="info_box">
        <div class="box_left">
          <div class="headPortraits">
            <div class="img_box">
              <img v-if="authorInfo.headimg_url" :src="authorInfo.headimg_url" alt />
              <img v-else src="../../assets/images/zhuzhou/head.png" alt />
            </div>
            <div class="name">
              <!-- {{authorInfo.user_name.replace(/(.{3}).*(.{4})/, '$1******$2') }} -->
              {{parseInt(authorInfo.user_name)?authorInfo.user_name.replace(/(.{3}).*(.{4})/, '$1******$2'):authorInfo.user_name}}
            </div>
            <div class="headPortraits_bottom">
              <div class="first">
                <span>{{authorInfo.comment_count}}</span>
                <div>跟帖</div>
              </div>
              <div>
                <span>{{authorInfo.view_count}}</span>
                <div>阅读量</div>
              </div>
            </div>
          </div>
        </div>
        <div class="box_right">
          <div class="info_title">
            <p># {{authorInfo.title}} #</p>
            <div class="btn" @click="goAnchor()">
              <img src="../../assets/images/zhuzhou/icon5.png" alt /> 回复
            </div>
          </div>
          <div class="content" v-html="authorInfo.content"></div>
          <!-- <div class="imgs" v-if="authorInfo.subsidiary_files">
            <img
              v-for="(item,index) in authorInfo.subsidiary_files"
              :key="index"
              :src="item.pub_file_text?item.pub_file_text.url:''"
              alt
            />
          </div>-->
          <div class="box_bottom">
            <div class="icon_box">
              <div class="date">{{authorInfo.created_at}}</div>
              <div @click="goAnchor()">
                <img src="../../assets/images/zhuzhou/icon4.png" alt />回复
              </div>
              <div
                v-if="!access_token||authorInfo.if_favorite==0"
                @click="favoriteClick"
                class="thumb"
              >
                <img src="../../assets/images/zhuzhou/icon8.png" alt />
                <span class="no-like">{{authorInfo.favorite_count}}</span>
              </div>
              <div v-else @click="deletFavorite" class="thumb">
                <img src="../../assets/images/zhuzhou/icon3.png" alt />
                <span>{{authorInfo.favorite_count}}</span>
              </div>
            </div>
            <!-- <ul v-if="showBox&&pId==item.id">
              <li v-for="(itm,index) in item.follow" :key="index">
                <div class="imgs">
                  <img src="../../assets/images/zhuzhou/head.png" alt />
                </div>
                <div class="li_info">
                  {{itm.name}}：
                  <span>{{itm.info}}</span>
                </div>
                <div class="date">{{itm.time}}</div>
                <div class="bttuon">回复</div>
              </li>
            </ul>-->
          </div>
        </div>
      </div>
      <div class="info_box" v-for="(item,index) in comment_list.data" :key="index">
        <div class="box_left">
          <div class="comment">
            <div class="img_box">
              <img v-if="authorInfo.headimg_url" :src="authorInfo.headimg_url" alt />
              <img v-else src="../../assets/images/zhuzhou/head.png" alt />
            </div>
            <div class="name">
              <!-- {{item.user_name.replace(/(.{3}).*(.{4})/, '$1******$2') }} -->
              {{parseInt(item.user_name)?item.user_name.replace(/(.{3}).*(.{4})/, '$1******$2'):item.user_name}}
            </div>
          </div>
        </div>
        <div class="box_right">
          <div class="content" v-html="item.comment"></div>
          <div class="box_bottom">
            <div class="icon_box">
              <div class="date">{{item.created_at}}</div>
            </div>
          </div>
        </div>
      </div>
      <div id="reply" class="reply">
        <div class="reply_title">
          <img src="../../assets/images/zhuzhou/icon6.png" alt />发布回复
        </div>
        <el-input
          :disabled="access_token?false:true"
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4}"
          v-model="textarea"
        ></el-input>
        <div v-if="!access_token" class="login">
          需要
          <span @click="dialogVisible = true">登录</span>才能回复
        </div>
      </div>
      <div class="bottom-btn">
        <div @click="btnClick">发布</div>
      </div>
    </div>
    <div v-if="total/page_size>1" class="pagination">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-size="page_size"
        layout=" prev, pager, next"
        :total="total"
        :prev-text="prevText"
        :next-text="nextText"
        :background="true"
        :hide-on-single-page="true"
      ></el-pagination>
      <div class="amount">共{{total}}篇话题/共{{Math.ceil(total/page_size)}}页</div>
    </div>

    <el-dialog
      title="登录"
      :visible.sync="dialogVisible"
      width="480px"
      :before-close="handleClose"
      :destroy-on-close="true"
    >
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
        <el-form-item prop="phone">
          <el-input @blur="detectionName" v-model="ruleForm.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入真实姓名"></el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input v-model="ruleForm.code" placeholder="请输入短信验证码"></el-input>
          <el-button :disabled="disabled" type="primary" @click="codeClick">{{codeTxte}}</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn" type="primary" @click="submitForm('ruleForm')">登录</el-button>
      </span>
    </el-dialog>
    <WtDataModal :show="cropperModal" :styles="{width:'340px'}" :isFooter="false">
      <div slot="body">
        <slide-verify
          @success="onSuccess"
          ref="verify"
          @fail="onFail"
          @refresh="onRefresh"
          :slider-text="text"
        ></slide-verify>
      </div>
    </WtDataModal>
    <homeFooter></homeFooter>
  </div>
</template>
<script>
import homeHead from "@/components/Public/head.vue";
import homeNav from "@/components/Public/nav.vue";
import breadcrumb from "@/components/Public/breadcrumb.vue";
import homeFooter from "@/components/Public/footer.vue";

export default {
  data() {
    return {
      cropperModal: false,
      text: "向右拖动滑块填充拼图",
      codeTime: "",
      textarea: "",
      access_token: "",
      prevText: "上一页",
      nextText: "下一页",
      currentPage: 1,
      showBox: false,
      placeholder: "",
      pId: 0,
      dialogVisible: false,
      infoList: [],
      ruleForm: {
        phone: "",
        name: "",
        code: ""
      },
      rules: {
        phone: [{ required: true, message: "请输入手机号码", trigger: "blur" }],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }]
      },
      codeTxte: "发送验证码",
      disabled: false,
      key: "",
      code: "",
      authorInfo: {},
      comment_list: {},
      total: null,
      page: 1,
      page_size: 8,
      positionData: [
        {
          title: "话题"
        },
        { title: "话题详情" }
      ]
    };
  },
  methods: {
    //查询姓名
    detectionName() {
      this.$db
        .get(this.$url.login.detection_name, { mobile: this.ruleForm.phone })
        .then(res => {
          if (res.code == 200) {
            this.ruleForm.name = res.data.name;
          }
        }).catch(err => {
            console.log(err);
          });
    },
    goTo() {
      // if(index==0){
      //  this.$router.push({ path: "/forum", query: { send_id: 1 } });
      // }
    },
    handleCurrentChange() {
      this.getListinfo();
      const returnEle = document.querySelector("#list");
      if (!!returnEle) {
        returnEle.scrollIntoView(true);
      }
    },
    handleClose(done) {
      this.ruleForm.phone = "";
      this.ruleForm.name = "";
      this.ruleForm.code = "";
      clearInterval(this.codeTime);
      this.disabled = false;
      this.codeTxte = "发送验证码";
      done();
    },

    //如果没有登录，那么弹出登录框
    loginTableOpenByToken() {
      if (!this.access_token) {
        this.dialogVisible = true;
      }
    },
    //话题点赞
    favoriteClick() {
      const _this = this;
      this.loginTableOpenByToken();
      if (!this.access_token) {
        return false;
      }
      let data = { article_id: _this.$route.query.pId, token: true };
      if (_this.access_token) {
        _this.$db.post(_this.$url.favorite.add_favorite, data).then(res => {
          if (res.code == 200) {
            _this.getListinfo();
          }
        }).catch(err => {
            console.log(err);
          });
      } else {
        this.$message({
          message: "登录后才能点赞！",
          type: "warning"
        });
      }
    },

    //获取验证码
    codeClick() {
      if (this.ruleForm.phone == "") {
        this.$message({
          message: "请输入手机号码",
          type: "warning"
        });
        return false;
      } else if (!/^[1][0-9]{10}$/.test(this.ruleForm.phone)) {
        this.$message({
          message: "手机号码格式错误！",
          type: "warning"
        });
        return false;
      } else {
        this.cropperModal = true;
      }
    },
    //滑动验证
    onSuccess() {
      this.cropperModal = false;
      let number = 60;
      let _this = this;
      this.disabled = true;
      let data = {
        mobile: _this.ruleForm.phone
      };
      this.$refs.verify.refresh();
      _this.$db.post(_this.$url.code.send_code, data).then(res => {
        if (res.code == 200) {
          _this.key = res.data.key;
          _this.code = res.data.code;
          if (res.data.code) {
            this.$message(res.data.code);
          }
        }
      }).catch(err => {
            console.log(err);
          });
      let time = setInterval(() => {
        number--;
        this.codeTime = time;
        _this.codeTxte = number + "s";
        if (_this.codeTxte == "0s") {
          clearInterval(time);
          _this.disabled = false;
          _this.codeTxte = "发送验证码";
        }
      }, 1000);
    },
    onFail() {

    },
    onRefresh() {

    },
    //用户登录
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (!/^[1][0-9]{10}$/.test(this.ruleForm.phone)) {
            this.$message.error("手机格式错误!");
            return false;
          } else if (!/^[\u4e00-\u9fa5]+$/.test(this.ruleForm.name)) {
            this.$message.error("姓名必须为中文且不能带特殊字符!");
          } else if (this.key == "") {
            this.$message.error("请先获取短信验证码！");
          } else {
            let _this = this;
            let data = {
              mobile: _this.ruleForm.phone,
              key: _this.key,
              code: _this.ruleForm.code,
              name: _this.ruleForm.name
            };
            _this.$db.post(_this.$url.login.user, data).then(res => {
              if (res.code == 200) {
                sessionStorage.setItem("access_token", res.data.access_token);
                _this.dialogVisible = false;
                _this.access_token = res.data.access_token;
                _this.getListinfo();
                this.$message.success("登录成功！");
              } else {
                this.$message.error(res.msg);
              }
            }).catch(err => {
            console.log(err);
          });
          }
        } else {
          return false;
        }
      });
    },
    //锚点定位
    goAnchor() {
      if (this.access_token) {
        const returnEle = document.querySelector("#reply");
        if (!!returnEle) {
          returnEle.scrollIntoView(true);
        }
      } else {
        this.loginTableOpenByToken();
        const returnEle = document.querySelector("#reply");
        if (!!returnEle) {
          returnEle.scrollIntoView(true);
        }
      }
    },
    //回复话题
    btnClick() {
      this.loginTableOpenByToken();
      if (!this.access_token) {
        return false;
      }
      const _this = this;
      let data = {
        article_id: _this.$route.query.pId,
        comment: _this.textarea,
        token: true
      };
      _this.$db.post(_this.$url.comment.send_comment, data).then(res => {
        if (res.code == 200) {
          _this.textarea = "";
          _this.$message.success("回复评论成功！");
        }
      }).catch(err => {
            console.log(err);
          });
    },
    //获取评论详情
    getListinfo() {
      const _this = this;
      _this.$db
        .get(
          _this.$url.topic.info +
            "/" +
            _this.$route.query.pId +
            "?page=" +
            this.page +
            "&page_size=" +
            this.page_size,
          {
            token: true
          }
        )
        .then(res => {
          if (res.code == 200) {
            _this.authorInfo = res.data.article;
            _this.comment_list = res.data.comment_list;
            _this.total = res.data.article.comment_count;
          }
        }).catch(err => {
            console.log(err);
          });
    },
    //取消点赞
    deletFavorite() {
      this.loginTableOpenByToken();
      if (!this.access_token) {
        return false;
      }
      const _this = this;
      _this.$db
        .delete(
          _this.$url.favorite.add_favorite + "/" + _this.$route.query.pId,
          { token: true }
        )
        .then(res => {
          if (res.code == 200) {
            _this.getListinfo();
          }
        }).catch(err => {
            console.log(err);
          });
    }
  },
  mounted() {
    //获取存储的token
    const _this = this;
    let access_token = sessionStorage.getItem("access_token");
    if (access_token) {
      _this.access_token = access_token;
    }
    _this.getListinfo();
  },

  components: {
    homeHead,
    homeNav,
    breadcrumb,
    homeFooter
  }
};
</script>
<style lang="less" scoped>
.forumInfo {
  .colspan {
    margin: 0 auto;
    width: 1200px;
    height: 50px;
    background-color: #f3f3f3;
    color: #888888;
    font-size: 16px;
    margin-top: 14px;
    margin-bottom: 20px;
    > .weizhi {
      float: left;
      line-height: 50px;
      margin-left: 10px;
      > img {
        vertical-align: text-top;
      }
    }
    > .el-breadcrumb {
      line-height: 50px;
    }
  }
  .list-box {
    width: 1200px;
    background-color: #ffffff;
    border: solid 2px #2bba6b;
    margin: 0 auto;
    margin-top: 50px;
    .info_box {
      display: flex;
      min-height: 240px;
      padding-bottom: 28px;
      border-bottom: 1px solid #e5e5e5;
      .box_left {
        background-color: #f8fff8;
        width: 240px;
        overflow: hidden;
        .headPortraits {
          width: 200px;
          background: url("../../assets/images/zhuzhou/head_icon.png") no-repeat;
          background-position: 130px -25px;
          border: solid 1px #e5e5e5;
          text-align: center;
          margin: 20px 0 0 20px;
          background-color: #fff;
          .img_box {
            width: 100px;
            margin: 32px auto 20px;
            > img {
              width: 100%;
              border-radius: 5px;
            }
          }
          .headPortraits_bottom {
            display: flex;
            justify-content: center;
            margin: 20px 0;
            > div {
              height: 48px;
              padding: 0 20px;
              > span {
                color: #e9831c;
              }
              > div {
                color: #888888;
                margin-top: 10px;
              }
            }
            .first {
              border-right: solid 1px #e5e5e5;
            }
          }
        }
        .comment {
          width: 200px;
          border: solid 1px #e5e5e5;
          text-align: center;
          margin: 20px 0 0 20px;
          background-color: #fff;
          padding-bottom: 36px;
          .img_box {
            width: 100px;
            margin: 32px auto 20px;
            > img {
              width: 100%;
              border-radius: 5px;
            }
          }
        }
      }
      .box_right {
        .info_title {
          margin: 35px 0 0 41px;
          display: flex;
          justify-content: space-between;
          > p {
            font-size: 24px;
            font-weight: bold;
            color: #229e62;
            margin: 0;
            line-height: 50px;
          }
          .btn {
            width: 130px;
            height: 50px;
            line-height: 50px;
            background-color: #2bba6b;
            border-radius: 5px;
            text-align: center;
            font-size: 20px;
            color: #fff;
            margin-left: 210px;
            cursor: pointer;
            > img {
              vertical-align: middle;
              margin-right: 10px;
            }
          }
        }
        .content {
          width: 832px;
          margin: 48px 0 80px 56px;
        }
        .box_bottom {
          padding: 40px 0 0 56px;
          .icon_box {
            display: flex;
            justify-content: flex-end;
            cursor: pointer;
            > div {
              color: #888;
              height: 44px;
              line-height: 44px;
              text-align: center;
              > img {
                vertical-align: middle;
                margin-right: 10px;
              }
            }
            div:nth-of-type(2) {
              width: 104px;
            }
            .active {
              background-color: #f4f4f4;
            }
            .thumb {
              > img {
                margin-top: -9px;
              }
              .no-like {
                color: #888888;
              }
            }
            .date {
              color: #888888;
            }
            div:nth-of-type(2) {
              margin: 0 20px;
            }
          }
          > ul {
            list-style: none;
            background-color: #f4f4f4;
            padding: 0;
            width: 835px;
            margin: 0;
            > li {
              width: 100%;
              height: 92px;
              line-height: 92px;
              display: flex;
              .imgs {
                width: 54px;
                margin: 18px 13px 0 27px;
                > img {
                  width: 100%;
                }
              }
              .li_info {
                width: 583px;
                span {
                  color: #404040;
                }
              }
              .date {
                color: #888;
                margin-right: 10px;
              }
              .bttuon {
                color: #888;
                cursor: pointer;
              }
            }
          }
        }
        .imgs {
          width: 836px;
          margin: 0 auto;
          > img {
            width: 100%;
          }
        }
      }
    }
    .reply {
      min-height: 300px;
      padding: 57px 59px 0 62px;
      position: relative;
      .reply_title {
        font-size: 20px;
        color: #239e61;
        font-weight: 700;
        margin-bottom: 30px;
        > img {
          vertical-align: middle;
          margin-right: 12px;
        }
      }
      /deep/.el-textarea__inner {
        min-height: 240px !important;
        padding: 25px 15px 5px 27px;
        border: none;
        background-color: #f4f4f4;
        color: #000;
      }
      /deep/.el-textarea__inner::placeholder {
        font-size: 18px;
        color: #999999;
      }
    }
  }
  .bottom-btn {
    width: 1200px;
    display: flex;
    justify-content: flex-end;
    margin: 26px 0 34px 0;
    > div {
      width: 120px;
      height: 56px;
      line-height: 56px;
      color: #fff;
      text-align: center;
      background-color: #2bba6b;
      float: right;
      font-size: 20px;
      margin: 10px 59px 0 0;
      cursor: pointer;
    }
  }
  .login {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, 200%);
    font-size: 18px;
    > span {
      color: #229e62;
      margin: 0 5px;
      cursor: pointer;
    }
  }
  .pagination {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    .amount {
      height: 26px;
      line-height: 28px;
      border: 1px solid #dcdfe6;
      padding: 0 10px;
      font-size: 13px;
      color: #888;
      margin-top: 52px;
    }
    /deep/ .el-pagination {
      margin: 50px 0 0 450px;
    }
  }
  /deep/ .btn {
    width: 100%;
    background-color: #2bba6b;
    > span {
      font-size: 20px;
    }
  }
  /deep/ .el-form-item__content {
    display: flex;
    /deep/ .el-input__inner {
      border-radius: 0;
    }
    .el-button--primary {
      padding: 0;
      width: 120px;
      height: 40px;
      border-radius: 0;
      background-color: #f3f3f3;
      padding: 0 15px;
      border-color: #e0e0e0;
      color: #2bba6b;
      border-left: none;
    }
  }
}

/deep/ .el-input__inner::placeholder {
  color: #8f8787;
}
/deep/ .el-pagination {
  margin-top: 107px;
  display: flex;
  justify-content: center;
  /deep/ .el-pager li {
    color: #888;
  }
  /deep/ button span {
    color: #888;
  }
  /deep/ .el-pager li.active {
    color: #fff !important;
  }
}
/deep/ .el-dialog {
  height: 428px;
  padding: 50px 65px 68px 65px;
}
/deep/ .el-dialog__header {
  padding: 0;
  margin: 0 0 35px 13px;
}
/deep/ .el-dialog__title {
  font-size: 24px;
  margin-bottom: 25px;
}
/deep/ .el-input {
  margin-bottom: 12px;
}
/deep/ .el-dialog__body {
  padding: 0;
}
/deep/ .el-dialog__footer {
  padding: 0;
  margin-top: 59px;
}
/deep/ .el-button--primary {
  border-color: #fff;
}
/deep/ .el-input {
  margin-bottom: 0;
}
/deep/ .content {
  img {
    width: 100%;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/forum/info.vue